'use client';

import { useEffect } from 'react';
import { track } from '@/lib/analytics/events';

function getDomain(u?: string) {
  try {
    return u ? new URL(u).hostname : undefined;
  } catch {
    return undefined;
  }
}

export default function AutoClickEvents() {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = (e.target as HTMLElement)?.closest<HTMLElement>('[data-analytics],[data-analytics-label],a');
      if (!target || target.hasAttribute('data-skip-autoclick')) return;

      const sectionEl = target.closest<HTMLElement>('section[id]');
      const section_id = sectionEl?.id;
      const section_title = sectionEl?.dataset.sectionTitle || sectionEl?.getAttribute('aria-label') || undefined;

      const analytics = target.getAttribute('data-analytics') || undefined;
      const text = (target.getAttribute('data-analytics-label') || target.textContent || '').trim().slice(0, 120);

      if (target.tagName === 'A') {
        const a = target as HTMLAnchorElement;
        const rawHref = a.getAttribute('href') || a.href || '';
        const isHash = rawHref.startsWith('#');
        const link_url = isHash ? `${window.location.origin}/${rawHref}` : a.href;
        const link_domain = isHash ? window.location.hostname : getDomain(link_url);
        const outbound = !!(link_domain && link_domain !== window.location.hostname);
        const target_section_id = isHash ? rawHref.slice(1) || undefined : undefined;
        const target_section_title = target_section_id
          ? document.getElementById(target_section_id)?.getAttribute('data-section-title') ||
            document.getElementById(target_section_id)?.getAttribute('aria-label') ||
            undefined
          : undefined;
        // Outbound clicks are handled by EM; ignore those here
        if (outbound) return;
        if (analytics === 'cta') {
          track.cta({
            cta_id: target.getAttribute('id') || 'cta',
            cta_text: text,
            link_url,
            link_domain,
            section_id,
            section_title,
          });
          return;
        }
        // Internal / hash navigation
        track.nav({
          link_url,
          link_domain,
          link_text: text,
          section_id,
          section_title,
          target_section_id,
          target_section_title,
        });
      } else {
        if (analytics === 'cta') {
          // CTA button (non-link)
          track.cta({
            cta_id: target.getAttribute('id') || 'cta',
            cta_text: text,
            section_id,
            section_title,
          });
        }
      }
    };

    document.addEventListener('click', handler, true);
    return () => document.removeEventListener('click', handler, true);
  }, []);

  return null;
}
